<template>
  <div class="evaluation-answer-multiple">
    <el-checkbox-group
      v-model="question.$result"
      v-if="question.type==='multiple'"
    >
      <div
        class="answer-item"
        v-for="(answer, $index) in question.$answers"
        :key="$index"
      >
        <el-checkbox
          @change="onChange($event, answer)"
          :label="answer.$id"
          :disabled="disabled"
        >
          {{ answer.name }}
        </el-checkbox>
      </div>
    </el-checkbox-group>
  </div>
</template>

////////////////////////////
//                   SCRIPT
////////////////////////////
<script>
export default {
  name: 'EvaluationAnswerMultiple',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    branchType: {
      type: String,
      required: true
    },
    question: {
      type: Object,
      required: true
    }
  },
  mounted () {
    this.calculateBaseScore()
  },
  methods: {
    calculateBaseScore () {
      this.question.$baseScore = 0
      for (let answer of this.question.$answers) {
        if (answer.$pointsPerBranch) {
          for (let branchPoints of answer.$branchPoints) {
            if (branchPoints.type === this.branchType) {
              this.question.$baseScore += branchPoints.points
            }
          }
        } else {
          this.question.$baseScore += answer.$points
        }
      }
    },
    checkInnerEvidenceRequired () {
      this.$set(this.question, 'innerEvidenceRequired', false)
      for (let result of this.question.$result) {
        for (let answer of this.question.$answers) {
          if (answer.$id === result && answer.$evidenceRequired) {
            this.question.innerEvidenceRequired = true
            return
          }
        }
      }
    },
    onChange (value, answer) {
      if (answer.$pointsPerBranch) {
        for (let branchPoints of answer.$branchPoints) {
          if (branchPoints.type === this.branchType) {
            this.question.$points += value
              ? branchPoints.points
              : branchPoints.points * -1
            break
          }
        }
      } else {
        this.question.$points += value ? answer.$points : answer.$points * -1
      }
      this.checkInnerEvidenceRequired()
    }
  }
}
</script>

////////////////////////////
//                    STYLE
////////////////////////////
<style
        lang="scss"
        scoped
>
.evaluation-answer-multiple {
  .answer-item {
    max-width: 100%;
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/evaluation/components/answers/evaluation-answer-multiple.vue